import(/* webpackMode: "eager" */ "/builds/qerko/qerko/frontend/link/src/app/loading.tsx");
